export default {
  name: "HeaderSubSection",
  props: ["headerImg"],
  methods: {
    imgLink() {
      return "background-image: url(images/" + this.$props.headerImg + ");";
    },
  },
};
